import { Button } from "apps/labelstudio/src/components";
import { Modal } from "apps/labelstudio/src/components/Modal/ModalPopup";
import { useCurrentUser } from "apps/labelstudio/src/providers/CurrentUser";
import { useCallback, useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { useAPI } from "../../../providers/ApiProvider";

interface OrganizationAPIItem {
    id: number;
    title: string;
}

interface Department {
    value: number;
    label: string;
}

let globalDep: Department = { 'label': "", 'value': 0 };

export function SwitchDepartment({
    opened,
    onOpened,
    onClosed,
}: {
    opened: boolean;
    onOpened?: () => void;
    onClosed?: () => void;
}) {
    const modalRef = useRef<Modal>();
    const { user: me } = useCurrentUser();
    const [departments, setDepartments] = useState<Department[]>([]);
    const [selectedDep, setSelectedDep] = useState<Department | null>(null);
    const api = useAPI();
    if (window.APP_SETTINGS) {
        window.APP_SETTINGS = {
            ...(window.APP_SETTINGS ?? {}), user: {
            id: me.id,
            username: me.username,
            firstName: me.first_name,
            lastName: me.last_name,
            initials: me.initials,
            email: me.email,
            allow_newsletters: "false",

        } };
    }
    useEffect(() => {
        async function fetchOrgs() {
            try {
                const res = await api.callApi("listAllOrganization");
                if (!res) {
                    throw new Error(`HTTP error!`);
                }
                const items: OrganizationAPIItem[] = res?.data;
                const mapped: Department[] = items.map((org) => ({
                    value: org.id,
                    label: org.title,
                }));
                setDepartments(mapped);
                if (mapped.length > 0 && !selectedDep) {
                    setSelectedDep(mapped[0]);
                }
            } catch (err) {
                console.error("fetch organizations failed:", err);
                setDepartments([]);
                setSelectedDep(null);
            }
        }
        fetchOrgs();
    }, []);

    useEffect(() => {
        if (modalRef.current && opened) {
            modalRef.current.show();
        } else if (modalRef.current && modalRef.current.visible) {
            modalRef.current.hide();
        }
    }, [opened]);

    const handleSubmit = useCallback(async () => {
        if (!globalDep.value || !globalDep.label) return;
        const res = await api.callApi("switchOrganization", {
            body: { department_id: globalDep.value, department_name: globalDep.label },
        });
        if (!res) {
            alert("Update Failed");
        } else {
            alert("Update Finished");
        }
        onClosed?.();
        location.reload();
    }, [selectedDep]);

    if (!me || !departments || !selectedDep) {
        return null;
    }

    return (
        <Modal
            ref={modalRef}
            title="Switch Department"
            opened={opened}
            body={
                <div className="block">
                    {/* <div>
                        <label className="block text-sm font-medium">User Name</label>
                        <div className="mt-2 p-2 bg-neutral-surface rounded">
                            {me.username}
                        </div>
                    </div> */}
                    <div>
                        <label className="block text-sm font-medium">Current Department</label>
                        <div className="mt-2 p-2 bg-neutral-surface rounded">
                            {me.active_organization_meta.title}
                        </div>
                    </div>
                    <div className="mt-2 block w-full">
                        <label aria-label="department" className="block text-sm font-medium">Switch Department</label>
                        <Select<Department, false>
                            inputId="switch-department"
                            options={departments}
                            onChange={(dep) => {
                                if (dep) {
                                    globalDep = dep;
                                    setSelectedDep(dep);
                                }
                            }}
                            placeholder="Please select a department"
                            menuShouldBlockScroll={true}
                            maxMenuHeight={260}
                        />
                    </div>
                </div>
            }
            footer={
                <div className="flex justify-end gap-2 z-99">
                    <Button variant="secondary" onClick={onClosed} style={{ width: 100 }}>
                        Cancel
                    </Button>
                    <Button look="primary" onClick={handleSubmit} style={{ width: 100 }}>
                        Confirm
                    </Button>
                </div>
            }
            style={{ width: 480 }}
            onHide={onClosed}
            onShow={onOpened}
        />
    );
}
